import MediumContainer from 'components/MediumContainer'
import ViewContainer from './container'
import SuggestedProducts from './SuggestedProducts'
import SearchResults from './SearchResults'

export default function Index ({ ...pageProps }) {
  return (
    <ViewContainer {...pageProps}>
      {({ search }) => (
        <MediumContainer>
          {search && (<SearchResults />)}
          <SuggestedProducts />
        </MediumContainer>
      )}
    </ViewContainer>
  )
}
